// routeConfig.js
import React from 'react';
import { SlCalender } from 'react-icons/sl';
import { GiFarmer } from 'react-icons/gi';
import { TbReportAnalytics } from 'react-icons/tb';
import { FaBugSlash, FaDatabase, FaTableList } from 'react-icons/fa6';
import { MdOutlineRule, MdOutlineSms } from 'react-icons/md';
import infection_alertIcon from 'assets/img/icons/weatherIcon.png';
import weather_alertIcon from 'assets/img/icons/weather_alert.png';
import overviewIcon from 'assets/img/icons/overview.png';
import alert_reportIcon from 'assets/img/icons/alert_reports.png';
import weather_forecastIcon from 'assets/img/icons/weather_forecast.png';
import demo_plotsIcon from 'assets/img/icons/demo_plots.png';
import smsIcon from 'assets/img/icons/sms.png';
import cultivationIcon from 'assets/img/icons/cultivation.png';
import farmer from 'assets/img/icons/farmer.png';
import satellite from 'assets/img/icons/satellite.png';
import settings from 'assets/img/icons/settings.png';
import reports from 'assets/img/icons/reports.png';
import dashboard from 'assets/img/icons/dashboard.png';
import sms_log_report from 'assets/img/icons/sms_log_report.png';
import crop_calendar from 'assets/img/icons/crop_calendar.png';
import field_officer from 'assets/img/icons/field_officer.png';
import procurement from 'assets/img/icons/procurement.png';
import market_price from 'assets/img/icons/market_price.png';
import farmer_group from 'assets/img/icons/farmer_group.png';
import center_list from 'assets/img/icons/center_list.png';

// Define base routes available to all clients
export const baseRoutes = {};

// Define client-specific route configurations
export const clientRoutes = {
  AMBUJAFOUNDATION: {
    additionalRoutes: ['comparison', 'villageLevel', 'farmLevel', 'monitoring']
  },
  MRV: {
    additionalRoutes: [
      'monitoring',
      'comparison',
      'villageLevel',
      'perilAlerts',
      'cultivationReport',
      'farmerReport',
      'farmlandReport',
      'farmerGroupReport',
      'weatherReport',
      'dashboardAnalytics',
      'plotOverlay',
      'farmLevel',
      'cropInfectionReport',
      'smsManagement',
      'smslogReport',
      'cropInfectionRuleReport',
      'smsDashboard',
      'cropCalendarReport',
      'fieldOfficerReport',
      'cropcalendarRuleReport',
      'marketpriceReport'
    ]
  },
  RPLC: {
    additionalRoutes: ['monitoring', 'comparison', 'plotOverlay', 'farmLevel']
  },
  SESTA: {
    additionalRoutes: ['monitoring', 'comparison']
  },
  TNSMRV: {
    additionalRoutes: [
      'dashboard',
      'alertsReport',
      'satelliteMRV',
      'reports',
      'settings',
      'offlineData'
    ]
  }
};

// Define additional routes that can be added based on client
export const additionalRoutes = {
  monitoring: {
    name: 'Monitoring',
    icon: SlCalender,
    path: 'monitor',
    active: true
  },
  villageLevel: {
    name: 'Village Level Data',
    icon: FaTableList,
    path: 'village',
    active: true
  },
  perilAlerts: {
    name: 'Peril Alerts',
    icon: TbReportAnalytics,
    path: 'perilAlerts',
    active: true
  },
  weatherReport: {
    name: 'Weather Forecast Report',
    icon: TbReportAnalytics,
    path: 'weatherReport',
    active: true
  },
  dashboardAnalytics: {
    name: 'Dashboard Analytics',
    icon: TbReportAnalytics,
    path: 'dashboardAnalytics',
    active: true
  },
  plotOverlay: {
    name: 'Plot Overlay & Comparison',
    icon: GiFarmer,
    path: 'plotoverlay',
    active: true
  },
  farmLevel: {
    name: 'Farm-level Report',
    icon: TbReportAnalytics,
    path: 'farmlevelReport',
    active: true
  },
  smslogReport: {
    name: 'SMS Log Report',
    icon: MdOutlineSms,
    path: 'smslogReport',
    active: true
  },
  comparison: {
    name: 'Comparison',
    icon: GiFarmer,
    path: 'comparison',
    active: true
  },
  cropInfectionReport: {
    name: 'Crop Infection Report',
    icon: FaBugSlash,
    path: 'cropInfection/report',
    active: true
  },
  cropInfectionRuleReport: {
    name: 'Crop Infection Rule Report',
    icon: MdOutlineRule,
    path: 'cropInfection/rules/report',
    active: true
  },
  marketpriceReport: {
    name: 'Market Price Report',
    icon: TbReportAnalytics,
    path: 'marketpriceReport',
    img: market_price,
    active: true
  },
  farmerGroupReport: {
    name: 'Farmer Group Report',
    icon: MdOutlineSms,
    path: 'farmerGroupReport',
    img: farmer_group,
    active: true
  },
  fieldOfficerReport: {
    name: 'Field Officer Report',
    icon: TbReportAnalytics,
    path: 'fieldOfficerReport',
    img: field_officer,
    active: true
  },
  cropcalendarRuleReport: {
    name: 'Crop Calendar Rule Report',
    icon: TbReportAnalytics,
    path: 'cropcalendarRuleReport',
    img: crop_calendar,
    active: true
  },
  procurementReport: {
    name: 'Procurement Report',
    icon: TbReportAnalytics,
    path: 'procurementReport',
    img: procurement,
    active: true
  },
  overview: {
    name: 'Overview',
    icon: MdOutlineSms,
    path: 'dashboardAnalytics',
    active: true,
    img: overviewIcon
  },
  sms: {
    name: 'SMS',
    icon: MdOutlineSms,
    path: 'sms-dashboard',
    active: true,
    img: smsIcon
  },
  dashboard: {
    name: 'Dashboard',
    icon: MdOutlineSms,
    path: 'dashboard',
    active: true,
    img: dashboard
  },
  weatherForecast: {
    name: 'Weather Forecast',
    icon: SlCalender,
    path: 'weatherReport',
    active: true,
    img: weather_forecastIcon
  },
  infectionAlert: {
    name: 'Infection Alert',
    icon: FaBugSlash,
    path: 'cropInfection/report',
    active: true,
    img: infection_alertIcon
  },
  weatherAlert: {
    name: 'Weather Alert',
    icon: SlCalender,
    path: 'perilAlerts',
    active: true,
    img: weather_alertIcon
  },
  alertsReport: {
    name: 'Alerts Report',
    icon: SlCalender,
    path: 'alerts',
    active: true,
    img: alert_reportIcon
  },
  demoPlots: {
    name: 'Demo Plots',
    icon: GiFarmer,
    path: 'farmlevelReport',
    active: true,
    img: demo_plotsIcon
  },
  satelliteMRV: {
    name: 'Satellite MRV',
    icon: GiFarmer,
    path: 'satellite-mrv',
    active: true,
    img: satellite
  },
  farmerReport: {
    name: 'Farmer Report',
    icon: TbReportAnalytics,
    path: 'farmerReport',
    active: true,
    img: farmer
  },
  farmlandReport: {
    name: 'Farmland Report',
    icon: TbReportAnalytics,
    path: 'farmlandReport',
    active: true,
    img: demo_plotsIcon
  },
  cultivationReport: {
    name: 'Cultivation Report',
    icon: TbReportAnalytics,
    path: 'cultivationReport',
    active: true,
    img: cultivationIcon
  },
  smsLogReport: {
    name: 'SMS Log Report',
    icon: TbReportAnalytics,
    path: 'smslogReport',
    active: true,
    img: sms_log_report
  },
  reports: {
    name: 'Reports',
    icon: TbReportAnalytics,
    path: 'reports',
    active: true,
    img: reports
  },
  Traceability: {
    name: 'Traceability',
    icon: TbReportAnalytics,
    path: 'Traceability',
    active: true,
    img: reports
  },
  cropCalendarReport: {
    name: 'Crop Calendar Report',
    icon: FaTableList,
    path: 'crop-calendar-report',
    img: crop_calendar,
    active: true
  },
  smsManagement: {
    name: 'SMS Management',
    icon: MdOutlineSms,
    path: 'sms-management',
    active: true,
    img: smsIcon
  },
  infectionRuleManagement: {
    name: 'Infection Rule Management',
    icon: MdOutlineRule,
    path: 'cropInfection/rules/report',
    active: true,
    img: infection_alertIcon
  },
  settings: {
    name: 'Settings',
    icon: MdOutlineSms,
    path: 'settings',
    active: true,
    img: settings
  },
  offlineData: {
    name: 'Offline Data',
    icon: MdOutlineSms,
    path: 'offline/data',
    active: true
  },
  centerListReport: {
    name: 'Center Addition',
    icon: TbReportAnalytics,
    path: 'centerList',
    active: true,
    img: center_list
  },
  receptionReport: {
    name: 'Receive Items',
    icon: TbReportAnalytics,
    path: 'receptionReport',
    active: true,
    img: center_list
  },
  transferReport: {
    name: 'Transfer Items',
    icon: TbReportAnalytics,
    path: 'transferReport',
    active: true,
    img: center_list
  },
  processReport: {
    name: 'Process Crops',
    icon: TbReportAnalytics,
    path: 'processReport',
    active: true,
    img: center_list
  },
  habitatMonitor: {
    name: 'Habitat Monitoring',
    icon: TbReportAnalytics,
    path: 'habitat',
    active: true,
    img: center_list
  }
};
